import { formattedDollarsToCents } from '@fruitful/fruitils';
import * as React from 'react';
import { useEffect, useState } from 'react';
import {
    Icon,
    InfoIcon,
    LabelRegular,
    StyledBodyMediumRegularInputNoOutline,
    View,
    XStack,
    YStack,
} from 'smoothie';

import {
    formatCurrencyInputOnChange,
    formatDollars,
    THOUSANDS_PLACE_COMMAS_REGEX,
} from '../../../../common/utils/bankingUtils';
import PaycheckRoutingCard from '../../paycheck-routing/common/PaycheckRoutingCard';

interface RuleAmountProps {
    amount?: number;
    updateAmount: (amount: number) => void;
    label: string;
    openInfoSheet?: () => void;
    width?: number;
    disabled?: boolean;
}

const RuleEditorAmount = ({
    amount,
    updateAmount,
    label,
    openInfoSheet,
    disabled,
    width,
}: RuleAmountProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const [formattedAmount, setFormattedAmount] = useState('');

    const formatAmount = (amount: number) => {
        if (!amount) return '$';

        const newFormattedAmount = Math.floor(amount / 100)
            .toString()
            .replace(THOUSANDS_PLACE_COMMAS_REGEX, ',');

        return `$${newFormattedAmount}`;
    };

    useEffect(() => {
        setFormattedAmount(formatAmount(amount ?? 0));
    }, [amount]);

    return (
        <YStack gap={8} width={width ?? '100%'}>
            <XStack gap={8} alignItems="center">
                <LabelRegular marginLeft={8} color="$gray1100">
                    {label}
                </LabelRegular>
                {openInfoSheet && (
                    <View
                        // onPress={() => {
                        //     setSheetOpen?.(true);
                        //     setContributionMaxType?.(contributionMaxType);
                        // }}
                        onPress={openInfoSheet}
                    >
                        <Icon size={12} color="$gray1100" icon={InfoIcon} />
                    </View>
                )}
            </XStack>
            <PaycheckRoutingCard
                onPress={() => {
                    if (!isEditing) setIsEditing(true);
                }}
                disabled={disabled}
            >
                <StyledBodyMediumRegularInputNoOutline
                    keyboardType="number-pad"
                    paddingHorizontal={0}
                    disabled={disabled}
                    value={formattedAmount === '' ? '$' : formattedAmount}
                    onChangeText={(incomingValue) => {
                        const newFormattedValue = formatCurrencyInputOnChange(
                            formatDollars(amount, false),
                            incomingValue,
                        );
                        const wholeDollarAmount =
                            newFormattedValue.split('.')[0] ?? '0';

                        updateAmount(
                            formattedDollarsToCents(wholeDollarAmount || '$0'),
                        );
                        setFormattedAmount(wholeDollarAmount);
                    }}
                    onBlur={() => {
                        setIsEditing(false);
                    }}
                    returnKeyType="done"
                    height={22}
                />
            </PaycheckRoutingCard>
        </YStack>
    );
};

export default RuleEditorAmount;
